import type { HTMLAttributes } from 'react';
import { Button } from '../../components/ui/button';
import { type CopyStatus, useCopyToClipboard } from '../hooks/useCopyToClipboard';
import { Icon } from '../icon/Icon';
import { cn } from '../utils';

const StatusIcon = ({ status }: { status: CopyStatus }) => {
  if (status === 'copied') {
    return <Icon name="check" className="size-icon-xs" />;
  }
  if (status === 'failed') {
    return <Icon name="close" className="size-icon-xs" />;
  }
  return <Icon name="copy" className="size-icon-sm" />;
};

export interface ErrorPageCodeProps extends HTMLAttributes<HTMLDivElement> {
  eventId: string;
  copyLabel: string;
  copiedLabel: string;
  copyFailedLabel: string;
}

export function ErrorPageCode({ eventId, copyLabel, copiedLabel, copyFailedLabel, className, ...props }: ErrorPageCodeProps) {
  const { status, copy } = useCopyToClipboard();

  if (!eventId) {
    return null;
  }

  const ariaLabel = { idle: copyLabel, copied: copiedLabel, failed: copyFailedLabel }[status];

  return (
    <div className={cn('flex items-center gap-2', className)} {...props}>
      <code className="font-mono text-muted-foreground text-sm">{eventId}</code>
      <Button variant="ghost" shape="pill" size="icon" iconOnly onClick={() => copy(eventId)} aria-label={ariaLabel}>
        <StatusIcon status={status} />
      </Button>
    </div>
  );
}
